import { withInstall } from '@bigin/utils'

import Slider from './src/slider.vue'

export const BSlider = withInstall(Slider)
export default BSlider

export * from './src/slider'
